import moment from 'moment';
import { DripCampaignProps } from './DripCampaignDetailsPanel';
import { CampaignSchedulerAttribute } from '@mm/state/model/CampaignsModel';
import WidgetModel from '@mm/state/model/WidgetModel';
import { widgetsByDialogueSelector } from '@mm/state/selectors/widgetSelectors';

const hasEmptyDialogue = (
  schedulersAttributes: CampaignSchedulerAttribute[],
  widgets: WidgetModel[],
) => {
  const filteredSchedulersAttributes = schedulersAttributes
    ? schedulersAttributes.filter(s => !s.destroy)
    : [];
  const widgetsByDialogues = filteredSchedulersAttributes.map(scheduler =>
    widgetsByDialogueSelector(scheduler.destinationPageId, widgets),
  );

  return widgetsByDialogues.some(widgets => !widgets.length);
};

const mapStateToCampaignErrors = (
  props: DripCampaignProps,
): { campaignErrors: string[] } => {
  const {
    name,
    includedAudiences,
    includedAudiencesIds,
    schedulersAttributes,
    acceptableTime,
    widgets,
    platforms,
    savedCampaign,
  } = props;
  const campaignErrors: string[] = [];
  const platformsValid =
    savedCampaign || Object.values(platforms).some(platform => platform);

  if (hasEmptyDialogue(schedulersAttributes, widgets)) {
    campaignErrors.push('Campaign Message Empty');
  }

  if (!name || !name.trim()) {
    campaignErrors.push('Campaign Name Required');
  }

  if (!includedAudiences.length && !includedAudiencesIds?.length) {
    campaignErrors.push('Audience Required');
  }

  if (!schedulersAttributes.length) {
    campaignErrors.push('Campaign Message Required');
  }
  if (acceptableTime) {
    const { startTime, stopTime } = acceptableTime;
    if (
      startTime &&
      stopTime &&
      moment(startTime, 'HH:mm')
        .add(1, 'hour')
        .isAfter(moment(stopTime, 'HH:mm'))
    ) {
      campaignErrors.push(
        'Schedule: Stop Time must be at least one hour after Start Time',
      );
    }
  }

  if (!platformsValid) {
    campaignErrors.push('Platform Required');
  }

  return { campaignErrors };
};

export { mapStateToCampaignErrors };
